var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MessageConfigs } from "../configurations";
import { VALIDATION_CHECK } from "../types/enumerations/validation";
export var getValidationRules = function (field, options, validationMessages) {
    if (options === void 0) { options = {}; }
    var newOptions = __assign({ required: true, whitespace: true, max: 250, min: 1 }, options);
    var required = newOptions.required, whitespace = newOptions.whitespace, type = newOptions.type, min = newOptions.min, max = newOptions.max, pattern = newOptions.pattern;
    var validationRules = [];
    required && validationRules.push({
        required: required, message: MessageConfigs.VALIDATION_MESSAGE.REQUIRED(field, validationMessages === null || validationMessages === void 0 ? void 0 : validationMessages[VALIDATION_CHECK.REQUIRED])
    });
    whitespace && validationRules.push({
        whitespace: true, message: MessageConfigs.VALIDATION_MESSAGE.EMPTY(field, validationMessages === null || validationMessages === void 0 ? void 0 : validationMessages[VALIDATION_CHECK.WHITESPACE])
    });
    max && validationRules.push({
        max: max, message: MessageConfigs.VALIDATION_MESSAGE.MAX_LIMIT(field, max, undefined, validationMessages === null || validationMessages === void 0 ? void 0 : validationMessages[VALIDATION_CHECK.MAX])
    });
    min && validationRules.push({
        min: min, message: MessageConfigs.VALIDATION_MESSAGE.MIN_LIMIT(field, min, undefined, validationMessages === null || validationMessages === void 0 ? void 0 : validationMessages[VALIDATION_CHECK.MIN])
    });
    type && validationRules.push({
        type: type, message: MessageConfigs.VALIDATION_MESSAGE.INVALID(field, validationMessages === null || validationMessages === void 0 ? void 0 : validationMessages[VALIDATION_CHECK.TYPE])
    });
    pattern && validationRules.push({
        pattern: pattern, message: MessageConfigs.VALIDATION_MESSAGE.INVALID(field, validationMessages === null || validationMessages === void 0 ? void 0 : validationMessages[VALIDATION_CHECK.PATTERN])
    });
    return validationRules;
};
//# sourceMappingURL=validation.js.map